import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "card"]

  select(event) {
    const category = event.currentTarget.dataset.category

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab === event.currentTarget)
    })

    this.cardTargets.forEach(card => {
      if (category === "all" || card.dataset.category === category) {
        card.style.display = ""
      } else {
        card.style.display = "none"
      }
    })
  }
}
